import React from "react";

function GameTermsAndConditions() {
  return (
    <main className="min-h-screen bg-gray-50">
      {/* HERO */}
      <section className="py-16 text-white bg-fordBlue">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="text-xs tracking-[0.12em] uppercase text-white/70 mb-3">
            Документ
          </div>

          <h1 className="text-3xl font-semibold leading-tight md:text-4xl">
            ОФИЦИАЛНИ ПРАВИЛА ЗА УЧАСТИЕ В ИГРАТА
          </h1>

          <p className="mt-4 text-base md:text-lg text-white/85">
            „Спечели двойна покана за One Night Stand от Ford“
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-12 pb-20">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="bg-white rounded-2xl shadow-sm ring-1 ring-black/5 p-6 md:p-10 text-[15px] leading-relaxed text-black/85">
            {/* SECTION I */}
            <Section title="РАЗДЕЛ I. ОРГАНИЗАТОР">
              <p>
                <strong>1.</strong> Играта „Спечели двойна покана за One Night
                Stand от Ford“ (наричана по-долу „Играта“) се организира и
                провежда от „Мото-Пфое“ ЕООД, със седалище и адрес на
                управление: гр. София, бул. Сливница № 444, наричано по-долу
                „Организатор“.
              </p>
              <p>
                <strong>2.</strong> Играта не е организирана, спонсорирана или
                по друг начин администрирана от Instagram (Meta Platforms Inc.).
              </p>
            </Section>

            {/* SECTION II */}
            <Section title="РАЗДЕЛ II. ПЕРИОД И ТЕРИТОРИЯ">
              <p>
                <strong>3.</strong> Играта се провежда в периода от 24.02.2025
                г. до 05.03.2026 г. включително.
              </p>
              <p>
                <strong>4.</strong> Играта се организира и провежда на
                територията на Република България чрез официалната Instagram
                страница на Ford Bulgaria:
              </p>
              <p>
                <a
                  href="https://www.instagram.com/fordbulgariatoday"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.instagram.com/fordbulgariatoday
                </a>
              </p>
            </Section>

            {/* SECTION III */}
            <Section title="РАЗДЕЛ III. ПРАВО НА УЧАСТИЕ">
              <p>
                <strong>5.</strong> Право на участие има всяко физическо лице,
                навършило 18 години към датата на стартиране на Играта и имащо
                постоянно или обичайно пребиваване в Република България.
              </p>
              <p>
                <strong>6.</strong> Нямат право на участие служители на
                Организатора, както и служители на рекламни агенции и други
                партньори, участващи в организацията на Играта, както и
                членовете на техните семейства (съпрузи и деца).
              </p>
              <p>
                <strong>7.</strong> Участието в Играта не е обвързано с покупка
                на стоки или услуги.
              </p>
              <p>
                <strong>8.</strong> С извършване на действие по участие,
                участникът декларира, че е запознат и приема настоящите правила.
              </p>
            </Section>

            {/* SECTION IV */}
            <Section title="РАЗДЕЛ IV. МЕХАНИЗЪМ НА ИГРАТА">
              <p>
                <strong>9.</strong> Играта се провежда на Instagram страницата
                на Ford Bulgaria.
              </p>
              <p>
                <strong>10.</strong> За да участва в томболата, лицето трябва:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  да последва страницата{" "}
                  <a
                    href="https://www.instagram.com/fordbulgariatoday"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                  >
                    https://www.instagram.com/fordbulgariatoday
                  </a>
                  ;
                </li>
                <li>
                  да отбележи в коментар приятел, с когото би посетил/а
                  събитието „One Night Stand“.
                </li>
              </ul>
              <p>
                <strong>11.</strong> Всеки участник има право на неограничен
                брой участия чрез отбелязване на различни профили, при условие
                че не нарушава настоящите правила и приложимото законодателство.
              </p>
              <p>
                <strong>12.</strong> Забранено е:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  използване на повече от един Instagram профил от едно и също
                  лице;
                </li>
                <li>използване на автоматизирани средства за участие;</li>
                <li>
                  съдържание, противоречащо на закона, добрите нрави или
                  етичните правила на Национален съвет за саморегулация;
                </li>
                <li>
                  съдържание, което представлява скрита реклама или нарушава
                  права на трети лица.
                </li>
              </ul>
              <p>
                <strong>13.</strong> Организаторът има право да дисквалифицира
                участник при установено нарушение.
              </p>
            </Section>

            {/* SECTION V */}
            <Section title="РАЗДЕЛ V. НАГРАДА И ТЕГЛЕНЕ">
              <p>
                <strong>14.</strong> Наградата представлява една от две двойни
                покани за събитието „One Night Stand“.
              </p>
              <p>
                <strong>15.</strong> На 05.03.2026 г. ще бъдат изтеглени двама
                печеливши участници на случаен принцип чрез електронна платформа
                за случайно генериране.
              </p>
              <p>
                <strong>16.</strong> Печелившите участници ще бъдат обявени чрез
                Instagram профила на страницата на Ford Bulgaria.
              </p>
              <p>
                <strong>17.</strong> В срок до 1 календарен ден от обявяването
                печелившият следва да се свърже с Организатора.
              </p>
              <p>
                <strong>18.</strong> Ако печелившият не осъществи контакт в
                посочения срок, той губи правото си върху наградата.
              </p>
              <p>
                <strong>19.</strong> Наградата не може да бъде заменяна срещу
                паричната ѝ равностойност.
              </p>
              <p>
                <strong>20.</strong> Ако стойността на наградата подлежи на
                облагане, дължимият данък се поема от Организатора.
              </p>
            </Section>

            {/* SECTION VI */}
            <Section title="РАЗДЕЛ VI. ОГРАНИЧАВАНЕ НА ОТГОВОРНОСТТА">
              <p>
                <strong>21.</strong> Организаторът не носи отговорност за:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>технически проблеми в платформата Instagram;</li>
                <li>загуба на данни поради хакерски атаки;</li>
                <li>обстоятелства на непреодолима сила.</li>
              </ul>
              <p>
                <strong>22.</strong> Организаторът не носи отговорност за
                претенции за награди след изтичане на срока по т. 17.
              </p>
            </Section>

            {/* SECTION VII */}
            <Section title="РАЗДЕЛ VII. ПРЕКРАТЯВАНЕ НА ИГРАТА">
              <p>
                <strong>23.</strong> Организаторът има право да прекрати Играта
                предсрочно при форсмажорни обстоятелства.
              </p>
            </Section>

            {/* SECTION VIII */}
            <Section title="РАЗДЕЛ VIII. ЗАЩИТА НА ЛИЧНИТЕ ДАННИ">
              <p>
                <strong>24.</strong> Организаторът обработва лични данни
                съгласно Регламент (ЕС) 2016/679 и Закона за защита на личните
                данни.
              </p>
              <p>
                <strong>25.</strong> Данните могат да включват:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>потребителско име в Instagram;</li>
                <li>три имена;</li>
                <li>телефон и/или имейл за контакт (само за печелившите).</li>
              </ul>
              <p>
                <strong>29.</strong> Искания могат да се изпращат на{" "}
                <a
                  href="mailto:privacy@motopfohe.bg"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  privacy@motopfohe.bg
                </a>
              </p>
            </Section>

            {/* SECTION IX */}
            <Section title="РАЗДЕЛ IX. ДРУГИ РАЗПОРЕДБИ">
              <p>
                <strong>30.</strong> Организаторът има право да изменя
                правилата, като измененията влизат в сила от момента на
                публикуването им.
              </p>
              <p>
                <strong>31.</strong> За всички неуредени въпроси се прилага
                действащото българско законодателство.
              </p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-12">
      <h2 className="text-lg md:text-xl font-semibold text-[#0b1f33] mb-5">
        {title}
      </h2>
      <div className="grid gap-3.5">{children}</div>
    </div>
  );
}

export default GameTermsAndConditions;
